import { IBlockReason, IGetBlockReasonsParams } from '@src/models/BlockReason'
import { IPayload } from 'models/Global'
import { AxiosService } from '../config/config'
import { Endpoints } from '../config/endpoints'

export class BlockReasonsApi {
  constructor(private axios: AxiosService) {}

  getBlockReasons = async (params?: IGetBlockReasonsParams) => {
    const response = await this.axios.get<IPayload<IBlockReason[]>>(
      Endpoints.getBlockReasons,
      params,
    )
    return response
  }

  getBlockReason = async (id: number, params?: IGetBlockReasonsParams) => {
    const response = await this.axios.get<IPayload<IBlockReason>>(
      Endpoints.getBlockReason(id),
      params,
    )
    return response
  }
}
